import { COGNITO_ADMIN } from 'config'
import { useAuth } from 'react-oidc-context'

export default function useGetAdminGroup() {
  const auth = useAuth()
  const rawGroups = auth.user?.profile?.['cognito:groups']
  const groups = Array.isArray(rawGroups) ? rawGroups : rawGroups ? [rawGroups] : []
  const adminGroup = groups.find((g) => g.endsWith(COGNITO_ADMIN)) ?? groups[0]

  return adminGroup
}
